module.exports = "https://cdn.realtymogul.com/static/media/David_K.7117be04.jpg";